import { eocUserResource } from '@atlassian/eoc-resources';

import { type ResourceDependencies } from '../../common/types';

import { createMyTeamsResource } from './my-teams';
import { createOpsTeamsResource } from './ops-teams';
import { createSchedulesResource } from './schedules';
import { createStatusResource } from './status';
import { createUserTimelineResource } from './user-timeline';

export const myTeamsResource = createMyTeamsResource();
export const opsTeamsResource = createOpsTeamsResource();
export const statusResource = createStatusResource();
export const userTimelineResource = createUserTimelineResource();
export const schedulesResource = createSchedulesResource();

export const resources = [
	eocUserResource,
	createMyTeamsResource(),
	createStatusResource(),
	createOpsTeamsResource(),
];

export const widgetResources = [
	() => eocUserResource,
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createMyTeamsResource(callback, depends),
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createStatusResource(callback, depends),
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createUserTimelineResource(callback, depends),
	(callback?: (dependencies: ResourceDependencies) => Promise<boolean>, depends?: string[]) =>
		createSchedulesResource(callback, depends),
];

export {
	createMyTeamsResource,
	createStatusResource,
	createUserTimelineResource,
	createSchedulesResource,
	createOpsTeamsResource,
};
